import React from 'react'
import moment from 'moment'

import NavLink from '../Routes/NavLink'

import { financial } from '../../core/controllers/Financial';
import { modal } from '../../core/utilities/modal';

export default class Income extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            amount: 0
        };
    }

    componentDidMount() {
        var self = this;
        // move to own component
        financial.getIncome(function(response) {
            var income = (response.data.income).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });

            self.setState({
                income: income
            })
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.filter != this.props.filter) {
            var self = this;
            // move to own component
            financial.getIncome(function(response) {
                var income = (response.data.income).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });

                self.setState({
                    income: income
                })
            });
        }
    }

    render(){
        return (
        <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="info-box">
                <span class="info-box-icon blue-icon-circle"><i class="icon-piggy-bank"></i></span>
                <div class="info-box-content">
                    <span class="info-box-text">Income</span>
                    <br/>
                    <span class="info-box-subtext">Total income received</span>
                    <span class="info-box-number blue-info-number" style={{fontSize: "35px"}}>{ this.state.income }</span>
                </div>
            </div>
        </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Financial/Income.jsx